/**
 * Formats a task's execution time for the progress summary.
 *
 * The backend sends execution_time as fractional seconds (for example
 * 66.557738999999998), which used to be printed as is (ZLAYT-1391). Round to
 * whole seconds before splitting into minutes so 59.6 reads "1m 0s", not
 * "60s", and show "<1s" rather than "0s" for very short steps.
 */
export const formatDuration = (seconds: number): string => {
  const total = Math.round(seconds);
  if (total < 1) return '<1s';
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
};
